export default __webpack_public_path__ + "static/media/Screenshot_1619919025.0132d68c.png";